import { CardLoader, ListPagination } from 'components/organisms'
import CmsStoryGroupTableRow from 'domains/cms-story-group/table/cms-story-group-table-row'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'

const propTypes = {
  tableProps        : PropTypes.object,
  cmsStoryGroups    : PropTypes.array,
  pagination        : PropTypes.object,
  isLoading         : PropTypes.bool,
  onClickPageDetail : PropTypes.func,
  onPageChange      : PropTypes.func
}

const defaultProps = {
  tableProps        : {},
  cmsStoryGroups    : [],
  pagination        : {},
  isLoading         : true,
  onClickPageDetail : () => { },
  onPageChange      : () => {}
}

/**
 * Table to display List of CMS::StoryGroups
 * @param {Object} tableProps - table properties
 * @param {Array} cmsStoryGroups - array of Cms StoryGroup
 * @param {Object} pagination - pagination object
 * @param {Boolean} isLoading
 * @param {Function} onClickPageDetail - handler function for click detail page
 * @param {Function} onPageChange - handler function to change the page
 */

const CmsStoryGroupTable = ({
  tableProps,
  cmsStoryGroups,
  pagination,
  isLoading,
  onClickPageDetail,
  onPageChange
}) => {
  const totalColumns           = 7
  const TableContent           = () => (
    <Table { ...tableProps }>
      <thead>
        <tr>
          <th scope="col">{ 'Id' }</th>
          <th scope="col">{ 'Title' }</th>
          <th scope="col">{ 'Thumbnail' }</th>
          <th scope="col">{ 'Active Status' }</th>
          <th scope="col">{ 'Starts At' }</th>
          <th scope="col">{ 'Expires At' }</th>
          <th scope="col">{ 'Action' }</th>
        </tr>
      </thead>
      <tbody>
        {
          cmsStoryGroups.map((cmsStoryGroup, index) => (
            <CmsStoryGroupTableRow
              key={ `cms-story-index${index}` }
              onRowClick={ onClickPageDetail }
              cmsStoryGroup={ cmsStoryGroup }
            />
          ))
        }

        {
          cmsStoryGroups.length === 0 &&
        <tr>
          <td
            colSpan={ totalColumns }
            className='bg-warning text-white'
          >
            <i className='fas fa-info-circle mr-3' />
            { 'Data Cms Story Group tidak ditemukan' }
          </td>
        </tr>
        }
      </tbody>
    </Table>
  )
  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <ListPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}

CmsStoryGroupTable.propTypes    = propTypes
CmsStoryGroupTable.defaultProps = defaultProps

export default CmsStoryGroupTable
